var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("timesheet-field", {
        attrs: { layout: _vm.fieldSelectorDropdownLayout, showAddButton: true },
        on: { change: _vm.onChange, addClick: _vm.showFieldFromSelector }
      }),
      _vm._v(" "),
      _vm._l(_vm.enabledFields, function(field, index) {
        return _c("timesheet-fieldset", {
          key: index,
          attrs: { layout: field },
          on: { change: _vm.onChange }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }